import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=3a0e8ef3&"
import script from "./tab.vue?vue&type=script&lang=js&"
export * from "./tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a0e8ef3')) {
      api.createRecord('3a0e8ef3', component.options)
    } else {
      api.reload('3a0e8ef3', component.options)
    }
    module.hot.accept("./tab.vue?vue&type=template&id=3a0e8ef3&", function () {
      api.rerender('3a0e8ef3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/fee/views/standby_fee/fee_pool_page_2/form/components/tab.vue"
export default component.exports